import { render, staticRenderFns } from "./ComplaintTrendsByDate.vue?vue&type=template&id=c8f45e64"
import script from "./ComplaintTrendsByDate.vue?vue&type=script&lang=js"
export * from "./ComplaintTrendsByDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports